import React from 'react'
import ReactModal from 'react-modal'

import CloseButton from '../CloseButton/CloseButton'
import { useAppSelector } from '../../hooks'

ReactModal.setAppElement(document.getElementById('mok-context-spa') as any)

const genericStyle = {
  overlay: {
    zIndex: 1206, // Needs to be higher then swipable drawer drawer and header to render on top
    backgroundColor: 'rgb(60 60 60 / 50%)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '95vw',
    maxHeight: '85vh',
    paddingTop: '20px',
  },
}

interface Props {
  isOpen: boolean
  onAfterOpen?: () => void
  onRequestClose: () => void
  onAfterClose?: () => void
  contentLabel: string
  children: React.ReactNode
  testId?: string
}

const Modal: React.FC<Props> = ({
  isOpen,
  onAfterOpen = () => {},
  onRequestClose,
  onAfterClose = () => {},
  contentLabel,
  children,
  testId,
}) => {
  const { content } = useAppSelector((state) => state.init)

  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      onAfterClose={onAfterClose}
      style={genericStyle}
      // String indicating how the content container should be announced to screenreaders
      contentLabel={contentLabel}
      testId={testId}
    >
      <CloseButton onClick={onRequestClose} label={content?.buttons?.close} />
      {children}
    </ReactModal>
  )
}

export default Modal
